import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

const GUEST_KEY = "wedding_guest";

export function getGuestSession() {
  try {
    return JSON.parse(sessionStorage.getItem(GUEST_KEY));
  } catch {
    return null;
  }
}

export function setGuestSession(session) {
  sessionStorage.setItem(GUEST_KEY, JSON.stringify(session));
  window.dispatchEvent(new Event("guest-session"));
}

export function clearGuestSession() {
  sessionStorage.removeItem(GUEST_KEY);
  window.dispatchEvent(new Event("guest-session"));
}

export function guestHeaders() {
  const s = getGuestSession();
  return s?.token ? { Authorization: `Bearer ${s.token}` } : {};
}

export function photoFileUrl(id) {
  const s = getGuestSession();
  return `${API}/photos/file/${id}?auth=${encodeURIComponent(s?.token || "")}`;
}

export function formatError(e, fallback = "Algo salió mal. Intenta de nuevo.") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return fallback;
}
